/** Departamentos y ciudades de Colombia (fuente DANE / app móvil). */
export const departamentosYCiudades = {
  "Amazonas": [
    "Leticia",
    "Puerto Nariño",
    "El Encanto",
    "La Chorrera",
    "La Pedrera",
    "Mirití-Paraná",
    "Puerto Alegría",
    "Puerto Arica",
    "Puerto Santander",
    "Tarapacá"
  ],
  "Antioquia": [
    "Medellín",
    "Bello",
    "Itagüí",
    "Envigado",
    "Apartadó",
    "Turbo",
    "Rionegro",
    "Caucasia",
    "Copacabana",
    "La Estrella",
    "Sabaneta",
    "Caldas",
    "Barbosa",
    "Girardota",
    "Marinilla",
    "El Carmen de Viboral",
    "La Ceja",
    "Yarumal",
    "Santa Rosa de Osos",
    "Chigorodó",
    "Carepa",
    "Necoclí",
    "Andes",
    "Cisneros",
    "Segovia",
    "El Bagre",
    "Zaragoza",
    "Puerto Berrío",
    "Remedios",
    "Amalfi"
  ],
  "Arauca": [
    "Arauca",
    "Arauquita",
    "Cravo Norte",
    "Fortul",
    "Puerto Rondón",
    "Saravena",
    "Tame"
  ],
  "Atlántico": [
    "Barranquilla",
    "Soledad",
    "Malambo",
    "Sabanalarga",
    "Baranoa",
    "Galapa",
    "Puerto Colombia",
    "Campo de la Cruz",
    "Luruaco",
    "Palmar de Varela",
    "Repelón",
    "Santo Tomás",
    "Juan de Acosta"
  ],
  "Bolívar": [
    "Cartagena",
    "Magangué",
    "Turbaco",
    "Arjona",
    "El Carmen de Bolívar",
    "San Juan Nepomuceno",
    "Santa Rosa del Sur",
    "Simití",
    "Mompós",
    "San Pablo",
    "María la Baja",
    "Mahates"
  ],
  "Boyacá": [
    "Tunja",
    "Duitama",
    "Sogamoso",
    "Chiquinquirá",
    "Paipa",
    "Puerto Boyacá",
    "Moniquirá",
    "Garagoa",
    "Villa de Leyva",
    "Samacá",
    "Nobsa",
    "Tibasosa",
    "Soatá",
    "Guateque",
    "Miraflores",
    "Ramiriquí"
  ],
  "Caldas": [
    "Manizales",
    "La Dorada",
    "Villamaría",
    "Chinchiná",
    "Riosucio",
    "Anserma",
    "Supía",
    "Aguadas",
    "Pácora",
    "Salamina",
    "Pensilvania",
    "Neira"
  ],
  "Caquetá": [
    "Florencia",
    "San Vicente del Caguán",
    "El Doncello",
    "Puerto Rico",
    "El Paujil",
    "Belén de los Andaquíes",
    "Cartagena del Chairá",
    "Curillo",
    "La Montañita",
    "Milán",
    "Morelia",
    "San José del Fragua",
    "Solano",
    "Solita",
    "Valparaíso",
    "Albania"
  ],
  "Casanare": [
    "Yopal",
    "Aguazul",
    "Villanueva",
    "Tauramena",
    "Paz de Ariporo",
    "Monterrey",
    "Maní",
    "Trinidad",
    "San Luis de Palenque",
    "Nunchía",
    "Hato Corozal",
    "Pore",
    "Orocué",
    "Tamara",
    "Recetor",
    "Chámeza",
    "La Salina",
    "Sácama",
    "Sabanalarga"
  ],
  "Cauca": [
    "Popayán",
    "Santander de Quilichao",
    "Puerto Tejada",
    "El Tambo",
    "Piendamó",
    "Patía",
    "Miranda",
    "Corinto",
    "Guapi",
    "Bolívar",
    "Caloto",
    "Timbío",
    "Silvia",
    "Toribío",
    "López de Micay"
  ],
  "Cesar": [
    "Valledupar",
    "Aguachica",
    "Codazzi",
    "Bosconia",
    "Chimichagua",
    "Curumaní",
    "La Jagua de Ibirico",
    "El Copey",
    "Pailitas",
    "Pelaya",
    "Río de Oro",
    "San Alberto",
    "San Diego",
    "San Martín",
    "Tamalameque"
  ],
  "Chocó": [
    "Quibdó",
    "Istmina",
    "Condoto",
    "Tadó",
    "Riosucio",
    "Bahía Solano",
    "Nuquí",
    "Acandí",
    "Bojayá",
    "El Cantón del San Pablo",
    "Medio Atrato",
    "Nóvita"
  ],
  "Córdoba": [
    "Montería",
    "Lorica",
    "Sahagún",
    "Cereté",
    "Montelíbano",
    "Planeta Rica",
    "Tierralta",
    "Ciénaga de Oro",
    "San Pelayo",
    "San Carlos",
    "Valencia",
    "Ayapel",
    "Chinú",
    "Purísima",
    "Momil"
  ],
  "Cundinamarca": [
    "Bogotá D.C.",
    "Soacha",
    "Girardot",
    "Zipaquirá",
    "Facatativá",
    "Chía",
    "Fusagasugá",
    "Mosquera",
    "Madrid",
    "Funza",
    "Cajicá",
    "Sibaté",
    "Tocancipá",
    "Sopó",
    "La Calera",
    "Cota",
    "Tenjo",
    "Tabio",
    "Villeta",
    "La Mesa",
    "Ubaté",
    "Pacho",
    "Guaduas",
    "Silvania",
    "Chocontá",
    "Nemocón",
    "Cogua",
    "Gachancipá"
  ],
  "Guainía": [
    "Inírida",
    "Barrancominas",
    "Mapiripana",
    "San Felipe",
    "Puerto Colombia",
    "La Guadalupe",
    "Cacahual",
    "Pana Pana",
    "Morichal"
  ],
  "Guaviare": [
    "San José del Guaviare",
    "Calamar",
    "El Retorno",
    "Miraflores"
  ],
  "Huila": [
    "Neiva",
    "Pitalito",
    "Garzón",
    "La Plata",
    "Campoalegre",
    "San Agustín",
    "Isnos",
    "Aipe",
    "Algeciras",
    "Gigante",
    "Rivera",
    "Timaná",
    "Palermo",
    "Yaguará",
    "Hobo"
  ],
  "La Guajira": [
    "Riohacha",
    "Maicao",
    "Uribia",
    "Manaure",
    "San Juan del Cesar",
    "Fonseca",
    "Barrancas",
    "Villanueva",
    "Hatonuevo",
    "Albania",
    "Dibulla",
    "Distracción",
    "El Molino",
    "La Jagua del Pilar",
    "Urumita"
  ],
  "Magdalena": [
    "Santa Marta",
    "Ciénaga",
    "Fundación",
    "Plato",
    "El Banco",
    "Aracataca",
    "Pivijay",
    "Zona Bananera",
    "Santa Ana",
    "Sitionuevo",
    "Salamina",
    "Concordia",
    "San Zenón",
    "Tenerife"
  ],
  "Meta": [
    "Villavicencio",
    "Acacías",
    "Granada",
    "Puerto López",
    "San Martín",
    "Cumaral",
    "Restrepo",
    "Guamal",
    "Castilla la Nueva",
    "San Juan de Arama",
    "El Dorado",
    "Barranca de Upía",
    "Puerto Gaitán",
    "Puerto Concordia",
    "Lejanías",
    "Vista Hermosa"
  ],
  "Nariño": [
    "Pasto",
    "Tumaco",
    "Ipiales",
    "Túquerres",
    "La Unión",
    "Samaniego",
    "Barbacoas",
    "El Charco",
    "Sandoná",
    "La Cruz",
    "Cumbal",
    "Ricaurte",
    "Olaya Herrera",
    "Roberto Payán",
    "Magüí Payán"
  ],
  "Norte de Santander": [
    "Cúcuta",
    "Ocaña",
    "Pamplona",
    "Los Patios",
    "Villa del Rosario",
    "El Zulia",
    "Tibú",
    "Convención",
    "Chinácota",
    "Ábrego",
    "Sardinata",
    "San Cayetano",
    "Puerto Santander",
    "Herrán"
  ],
  "Putumayo": [
    "Mocoa",
    "Puerto Asís",
    "Orito",
    "Valle del Guamuez",
    "Villagarzón",
    "Puerto Caicedo",
    "San Miguel",
    "Puerto Guzmán",
    "Puerto Leguízamo",
    "Santiago",
    "Colón",
    "Sibundoy",
    "San Francisco"
  ],
  "Quindío": [
    "Armenia",
    "Calarcá",
    "Montenegro",
    "La Tebaida",
    "Quimbaya",
    "Circasia",
    "Filandia",
    "Salento",
    "Génova",
    "Pijao",
    "Córdoba",
    "Buenavista"
  ],
  "Risaralda": [
    "Pereira",
    "Dosquebradas",
    "Santa Rosa de Cabal",
    "La Virginia",
    "Belén de Umbría",
    "Marsella",
    "Quinchía",
    "Apía",
    "Santuario",
    "Guática",
    "La Celia",
    "Balboa",
    "Pueblo Rico",
    "Mistrató"
  ],
  "San Andrés y Providencia": [
    "San Andrés",
    "Providencia"
  ],
  "Santander": [
    "Bucaramanga",
    "Floridablanca",
    "Girón",
    "Piedecuesta",
    "Barrancabermeja",
    "San Gil",
    "Socorro",
    "Barbosa",
    "Málaga",
    "Vélez",
    "Cimitarra",
    "Puerto Wilches",
    "Lebrija",
    "Rionegro",
    "Sabana de Torres",
    "Zapatoca"
  ],
  "Sucre": [
    "Sincelejo",
    "Corozal",
    "San Marcos",
    "Tolú",
    "San Onofre",
    "Ovejas",
    "Sampués",
    "Majagual",
    "Sucre",
    "San Juan de Betulia",
    "Los Palmitos",
    "Galeras",
    "Coveñas",
    "Morroa",
    "Guaranda",
    "La Unión"
  ],
  "Tolima": [
    "Ibagué",
    "Espinal",
    "Melgar",
    "Honda",
    "Mariquita",
    "Chaparral",
    "Líbano",
    "Fresno",
    "Guamo",
    "Flandes",
    "Lérida",
    "Purificación",
    "Saldaña",
    "San Luis",
    "Planadas",
    "Ortega"
  ],
  "Valle del Cauca": [
    "Cali",
    "Buenaventura",
    "Palmira",
    "Tuluá",
    "Buga",
    "Cartago",
    "Yumbo",
    "Jamundí",
    "Candelaria",
    "Florida",
    "Pradera",
    "Zarzal",
    "Dagua",
    "Sevilla",
    "Roldanillo",
    "Caicedonia",
    "El Cerrito",
    "La Unión",
    "Andalucía",
    "Ginebra"
  ],
  "Vaupés": [
    "Mitú",
    "Carurú",
    "Taraira",
    "Papunaua",
    "Yavaraté",
    "Pacoa"
  ],
  "Vichada": [
    "Puerto Carreño",
    "La Primavera",
    "Santa Rosalía",
    "Cumaribo"
  ]
};

export const departamentos = Object.keys(departamentosYCiudades).sort((a, b) => a.localeCompare(b, 'es'));

export function ciudadesDe(departamento) {
  return departamentosYCiudades[departamento] || [];
}
